import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=49afe042&scoped=true"
import script from "./CreateNews.vue?vue&type=script&lang=js"
export * from "./CreateNews.vue?vue&type=script&lang=js"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=49afe042&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afe042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49afe042')) {
      api.createRecord('49afe042', component.options)
    } else {
      api.reload('49afe042', component.options)
    }
    module.hot.accept("./CreateNews.vue?vue&type=template&id=49afe042&scoped=true", function () {
      api.rerender('49afe042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/CreateNews.vue"
export default component.exports